export default __webpack_public_path__ + "static/media/gem.7a617255.png";